import { Component, ElementRef, HostBinding, Input, OnInit, Renderer2 } from '@angular/core';
import Debug from 'debug';
const debug = Debug('aumico:core:AumicoButton');

const REQUIRED_CLASSES = 'btn btn-primary';
@Component({
    selector: 'aumico-button',
    templateUrl: 'aumico.button.component.html',
    styleUrls: ['aumico.button.component.scss'],
})
export class AumicoButton implements OnInit {
    protected _disabled = false;
    protected requiredClasses: string;
    @Input() click: any;
    @Input() set disabled(value: boolean) {
        this._disabled = value;
        let activeClasses = this.classes;
        activeClasses = activeClasses.replace(' disabled', '');
        if (value) {
            this.classes = activeClasses + ' disabled';
        } else {
            this.classes = activeClasses;
        }
    }

    @HostBinding('class') @Input() classes: string;
    @Input() set class(value: string) {
        this.classes = `${REQUIRED_CLASSES} ${value}`;
        if (this._disabled) {
            this.classes = this.classes + ' disabled';
        }
    }

    constructor(protected renderer: Renderer2, protected hostElement: ElementRef) {
        this.initClasses();
    }

    ngOnInit(): void {
        const firstchild = this.hostElement.nativeElement.children[0];
        if (!firstchild) {
            throw new Error('No child elements available');
        }
    }

    private initClasses(): void {
        this.class = ``;
    }
}
